"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NewLabel = _interopRequireDefault(require("../labels/NewLabel"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CovidHealthAndSafetyBanner = function CovidHealthAndSafetyBanner(_ref) {
  var showLink = _ref.showLink;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container covid-banner-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "CovidHealthAndSafetyBanner flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "margin-lg-bottom no-gutter col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "margin-xl-top margin-xl-bottom flex column-sm-reverse col-xs-9"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "h3"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_components.covid_health_and_safety_banner.title",
    defaultMessage: "Our COVID-19 Health & Safety Measures"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "flex middle"
  }, /*#__PURE__*/_react.default.createElement(_NewLabel.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-9 col-md-8"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "margin-xl-bottom"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_components.covid_health_and_safety_banner.covid_description",
    defaultMessage: "We\u2019ve provided guidelines and enhanced safety measures for hosts so guests can book with peace of mind."
  })), showLink && /*#__PURE__*/_react.default.createElement("a", {
    href: "https://book.peerspace.com/covid-19/overview",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "btn btn-default btn-outlined-light heavy"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_components.covid_health_and_safety_banner.learn_more",
    defaultMessage: "Learn more"
  }))))));
};
CovidHealthAndSafetyBanner.propTypes = {
  showLink: _propTypes.default.bool
};
var _default = exports.default = CovidHealthAndSafetyBanner;